interface SectionHeadingProps {
  /** Editorial index numeral, e.g. "01". */
  index?: string;
  /** Uppercase tracked kicker label. */
  kicker?: string;
  title: string;
  /** Lead paragraph shown beside/under the title. */
  lead?: string;
  align?: 'left' | 'center';
  tone?: 'dark' | 'light';
  className?: string;
}

export default function SectionHeading({
  index,
  kicker,
  title,
  lead,
  align = 'left',
  tone = 'dark',
  className = '',
}: SectionHeadingProps) {
  const light = tone === 'light';
  const centered = align === 'center';

  return (
    <div className={`${centered ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl'} ${className}`}>
      {(kicker || index) && (
        <div className={`kicker ${centered ? 'justify-center kicker-tight' : ''} ${light ? 'text-secondary-light' : ''}`}>
          {index && <span className="text-sm not-italic tracking-normal text-secondary">{index}</span>}
          {kicker && <span>{kicker}</span>}
        </div>
      )}
      <h2
        className={`mt-4 text-3xl font-semibold leading-[1.1] sm:text-4xl lg:text-[2.75rem] ${
          light ? 'text-white' : 'text-text-primary'
        }`}
      >
        {title}
      </h2>
      {lead && (
        <p className={`mt-5 max-w-2xl text-lg leading-8 ${centered ? 'mx-auto' : ''} ${light ? 'text-white/75' : 'text-text-secondary'}`}>
          {lead}
        </p>
      )}
    </div>
  );
}
